import { PinIcon } from "lucide-react";
import { APP_BAR_COLORS } from "../../app-bar-constants";

interface PinButtonProps {
	isPinned: boolean;
	onClick: () => void;
}

/**
 * PinButton - A button component that toggles pinning of the AppBar
 */
export const PinButton: React.FC<PinButtonProps> = ({ isPinned, onClick }) => {
	return (
		<button
			onClick={onClick}
			className={`flex justify-center items-center w-8 h-8 ${APP_BAR_COLORS.TEXT} hover:${APP_BAR_COLORS.TEXT_HOVER} focus:outline-none transition-opacity duration-200 ${
				isPinned ? "opacity-100" : "opacity-60 hover:opacity-100"
			}`}
			aria-label={isPinned ? "Unpin sidebar" : "Pin sidebar"}
		>
			<PinIcon size={16} className={isPinned ? "rotate-45" : ""} />
		</button>
	);
};
